module.exports = __webpack_public_path__ + "img/square-p.d0fbe050.svg";